import { Link } from "react-router-dom";
import errorPage from "images/errorPage_icon.svg";

const Index = () => {
  return (
    <section>
      <div className="errorPage">
        <div className="errorPageBox">
          <div className="icon">
            <img src={errorPage} alt="icon" />
          </div>
          <h2>OOPS！本頁無資料或資料尚未開放</h2>
          <p>
            您可以重新<Link to="/login">登入帳號</Link>或回到
            <Link to="/">首頁</Link>
          </p>
        </div>
      </div>
      {/* 錯誤訊息畫面 */}
    </section>
  );
};

export default Index;
